// extracted by mini-css-extract-plugin
export var actionText = "_mn-4";
export var container = "_mn-0";
export var leftSection = "_mn-1";
export var rightSection = "_mn-2";
export var settingsButton = "_mn-6";
export var settingsIcon = "_mn-7";
export var shortcut = "_mn-5";
export var shortcutGroup = "_mn-3";